import React from 'react'
import {colors} from "../../utils/styles"

const linkStyle = {
  color: colors.grayMiddle,
  textDecoration: 'none'
}

export const FooterLink = ({href, children}) => {
  return (
    <a style={linkStyle}
       href={href}
       target="_blank"
       rel="noopener noreferrer">{children}</a>
  )
}